import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import WorkTimesPage from './WorkTimesPage';

function SettingsPage() {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) {
    return <div className="container mt-5 text-center">Benutzerdaten werden geladen...</div>;
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Einstellungen</h3>
      <section>
        <WorkTimesPage embedded />
      </section>
    </div>
  );
}

export default SettingsPage;
